import Nav from "./nav"
import BackToTop from "./back-to-top"
import WcProductBundleComputeTotalsAfterDisccount from "./wc-product-bundle-compute-totals-after-disccount"
import AddToCartQuantity from "./add-to-cart-quantity"
import ContentFadeOut from "./content-fade-out"

// have to be load before add-to-cart-bundle.min.js which is executed before DOMContentLoaded
WcProductBundleComputeTotalsAfterDisccount(jQuery)

document.addEventListener("DOMContentLoaded", function () { 
    Nav(jQuery)
    AddToCartQuantity(jQuery)
    BackToTop(jQuery)
    ContentFadeOut(jQuery)
})
